import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

// Visible + semantic FAQ list. The FAQPage JSON-LD schema is set separately at the page level
// via the <SEO> component so Google sees both the rendered HTML and the structured data.
export default function FaqAccordion({ faqs, title = "Frequently asked questions", subtitle, theme = "light" }) {
  const [openIdx, setOpenIdx] = useState(0);
  if (!faqs?.length) return null;
  const dark = theme === "dark";
  return (
    <section className={dark ? "bg-[#0A0F1C] text-white py-20 lg:py-28" : "bg-white py-20 lg:py-28"} data-testid="faq-section">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <p className={`text-[10px] uppercase tracking-[0.3em] mb-5 ${dark ? "text-white/50" : "text-slate-500"}`}>FAQ</p>
        <h2 className={`font-display text-4xl lg:text-5xl font-bold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>{title}</h2>
        {subtitle && <p className={`mt-5 text-lg ${dark ? "text-white/70" : "text-slate-600"} max-w-2xl`}>{subtitle}</p>}
        <div className="mt-12 space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={i} className={`border ${dark ? "border-white/15" : "border-slate-200"}`} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className={`w-full text-left px-6 py-5 flex items-start justify-between gap-4 ${dark ? "hover:bg-white/5" : "hover:bg-slate-50"} transition-colors`}
                  aria-expanded={open}
                >
                  <span className={`font-display text-lg font-semibold pr-4 ${dark ? "text-white" : "text-slate-900"}`}>{f.q}</span>
                  <ChevronDown className={`w-5 h-5 flex-shrink-0 mt-1 transition-transform ${open ? "rotate-180" : ""} ${dark ? "text-white/60" : "text-slate-500"}`} />
                </button>
                {open && (
                  <div className={`px-6 pb-6 -mt-2 text-base leading-relaxed ${dark ? "text-white/75" : "text-slate-600"}`}>
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
